module.exports = function (app, mod) {
  return "<div class=\"main\">\n\t\t\t\t<div id=\"board\" class=\"board\"></div>\n\t\t\t</div>";
};